import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Services({ content }) {
  const services = content.services || [];

  // Bento layout: first card spans 2 columns on md+, rest are regular
  return (
    <section id="services" className="py-24 md:py-32 bg-neutral-50" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-16 items-end">
          <div className="md:col-span-8">
            <div className="text-sm uppercase tracking-widest text-orange-600 mb-4 font-medium" data-testid="services-eyebrow">
              — What we do best
            </div>
            <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-4xl sm:text-5xl md:text-6xl text-neutral-950">
              End-to-end home <br />
              <span className="text-orange-600">renovation & build</span>
            </h2>
          </div>
          <div className="md:col-span-4">
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed">
              From the studs to the paint. One licensed team — every trade, every project, every detail.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-6 gap-6 md:gap-8" data-testid="services-grid">
          {services.map((s, i) => {
            const spanClass =
              i === 0 ? "md:col-span-4 md:row-span-2 min-h-[520px]" :
              i === 1 ? "md:col-span-2 min-h-[250px]" :
              i === 2 ? "md:col-span-2 min-h-[250px]" :
              i === 3 ? "md:col-span-3 min-h-[280px]" :
              i === 4 ? "md:col-span-3 min-h-[280px]" :
              i === 5 ? "md:col-span-2 min-h-[260px]" :
              i === 6 ? "md:col-span-2 min-h-[260px]" :
              "md:col-span-2 min-h-[260px]";
            return (
              <motion.div
                key={s.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className={`group relative overflow-hidden bg-neutral-900 text-white ${spanClass}`}
                data-testid={`service-card-${i}`}
              >
                {s.image && (
                  <img
                    src={s.image}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-[opacity,transform] duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/50 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
                  <div className="flex items-end justify-between gap-4">
                    <div>
                      <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl leading-tight">
                        {s.title}
                      </h3>
                      <p className="mt-2 text-sm md:text-base text-neutral-300 max-w-md leading-relaxed">
                        {s.description}
                      </p>
                    </div>
                    <a
                      href="#contact"
                      className="shrink-0 w-12 h-12 flex items-center justify-center border border-white/30 group-hover:bg-orange-600 group-hover:border-orange-600 transition-colors"
                      data-testid={`service-cta-${i}`}
                      aria-label={`Learn more about ${s.title}`}
                    >
                      <ArrowUpRight className="w-5 h-5" />
                    </a>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
